module.exports = __webpack_public_path__ + "img/grp3.5230374e.png";